import { render, staticRenderFns } from "./VideoTutorialCard.vue?vue&type=template&id=2e1e20f2&"
import script from "./VideoTutorialCard.vue?vue&type=script&lang=js&"
export * from "./VideoTutorialCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports